import {FC, ReactNode} from 'react'
import cn from 'classnames'

import style from '@src/components/common/CheckBoxFormik/CheckBoxFormik.module.scss'
import {useDispatch} from "react-redux";
import {setIsPreorder} from "@src/store/ducks/orders/reducer";
import {useFormikContext} from "formik";

type CheckBoxFormikProps = {
    type?: string
    label?: string | ReactNode
    className?: string
    value?: string | number
    onChange?: (value?: any) => void
    checked?: boolean
    randomFilling?: any
}

export const CheckBoxPreBooking: FC<CheckBoxFormikProps> = ({
                                                                className,
                                                                type = 'checkbox',
                                                                label,
                                                                value,
                                                            }) => {
    const dispatch = useDispatch()
    const { values, setFieldValue } = useFormikContext<any>()
    const checked = Boolean(values.data.isPreorder)
    const handleChange = () => {
        const nextValue = checked ? 0 : 1

        setFieldValue('data.isPreorder', nextValue)
        dispatch(setIsPreorder(nextValue))
    }

    return (
        <div className={cn(style.box, style.boxPre,className)}>
            <label className={style.custom_checkbox}>
                <input
                    className={style.custom_checkbox}
                    type={type}
                    value={value}
                    onChange={handleChange}
                    checked={checked}
                />
                <span>
        {' '}
                    {label}
      </span>
            </label>
        </div>
    )
}
